"use client";

import qrcode from "qrcode-generator";
import { useMemo } from "react";

/** La zone de silence qu'exige la norme autour du code, en modules. */
const QUIET_ZONE = 4;

/**
 * Un QR code en SVG, d'un seul chemin.
 *
 * Dessiné ici plutôt qu'avec le balisage que la bibliothèque sait produire :
 * pas de HTML injecté, et un seul `<path>` là où une cellule par module ferait
 * des centaines de nœuds. Noir sur blanc quoi que dise le thème — un appareil
 * photo lit mal un code clair sur fond sombre.
 */
export function QrCode({ value, size, label }: { value: string; size: number; label: string }) {
  const { path, modules } = useMemo(() => {
    const code = qrcode(0, "M");

    code.addData(value);
    code.make();

    const count = code.getModuleCount();
    let d = "";

    for (let row = 0; row < count; row += 1) {
      for (let col = 0; col < count; col += 1) {
        if (code.isDark(row, col)) {
          d += `M${col} ${row}h1v1h-1z`;
        }
      }
    }

    return { path: d, modules: count };
  }, [value]);

  const box = modules + QUIET_ZONE * 2;

  return (
    <svg
      role="img"
      aria-label={label}
      width={size}
      height={size}
      viewBox={`${-QUIET_ZONE} ${-QUIET_ZONE} ${box} ${box}`}
      shapeRendering="crispEdges"
      style={{ background: "#ffffff", borderRadius: 10 }}
    >
      <path d={path} fill="#000000" />
    </svg>
  );
}
